import Api from '@/services/Api';

export default {
  getDiets() {
    return Api().get('diets/', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  createDiet(data: any) {
    return Api().post<{id: number, name: string, stream: string}>('diets/create', data, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  deleteTarget(dietId: any, nutrientId: any) {
    return Api().delete(`diets/targets/${dietId}/${nutrientId}`,{
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  saveTargets(targets: object[]) {
    return Api().post('diets/targets', { targets }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  updateDiet(id: number, data: any) {
    return Api().put(`diets/${id}`, data, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  deleteDiet(id: number) {
    return Api().delete(`diets/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  }
};
